/* ============================================
   NASHMI STORE - CUSTOM JAVASCRIPT FOR SHOPIFY
   Interactive Elements & Enhancements
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // 1. MOBILE MENU TOGGLE
  // ============================================
  
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const navMenu = document.querySelector('.nav-menu');

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function() {
      navMenu.classList.toggle('active');
      this.classList.toggle('active');
    });
  }

  // Close menu when a link is clicked
  const navLinks = document.querySelectorAll('.nav-menu a');
  navLinks.forEach(link => {
    link.addEventListener('click', function() {
      navMenu.classList.remove('active');
      if (mobileMenuBtn) mobileMenuBtn.classList.remove('active');
    });
  });

  // ============================================
  // 2. CART FUNCTIONALITY
  // ============================================

  class ShoppingCart {
    constructor() {
      this.items = this.loadCart();
      this.updateCartCount();
    }

    loadCart() {
      const saved = localStorage.getItem('nashmi_cart');
      return saved ? JSON.parse(saved) : [];
    }

    saveCart() {
      localStorage.setItem('nashmi_cart', JSON.stringify(this.items));
      this.updateCartCount();
    }

    addItem(product) {
      const existingItem = this.items.find(item => item.id === product.id);
      
      if (existingItem) {
        existingItem.quantity += product.quantity || 1;
      } else {
        this.items.push({
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.image,
          quantity: product.quantity || 1
        });
      }
      
      this.saveCart();
      this.showNotification('تم إضافة المنتج إلى السلة بنجاح');
    }

    removeItem(productId) {
      this.items = this.items.filter(item => item.id !== productId);
      this.saveCart();
    }

    updateQuantity(productId, quantity) {
      const item = this.items.find(item => item.id === productId);
      if (item) {
        item.quantity = Math.max(1, quantity);
        this.saveCart();
      }
    }

    getTotal() {
      return this.items.reduce((total, item) => total + (item.price * item.quantity), 0);
    }

    updateCartCount() {
      const cartCount = document.querySelector('.cart-count');
      const totalItems = this.items.reduce((sum, item) => sum + item.quantity, 0);
      
      if (cartCount) {
        cartCount.textContent = totalItems;
        cartCount.style.display = totalItems > 0 ? 'flex' : 'none';
      }
    }

    showNotification(message) {
      const notification = document.createElement('div');
      notification.className = 'notification notification-success';
      notification.textContent = message;
      document.body.appendChild(notification);

      setTimeout(() => {
        notification.classList.add('show');
      }, 10);

      setTimeout(() => {
        notification.classList.remove('show');
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }

    clear() {
      this.items = [];
      this.saveCart();
    }
  }

  // Initialize cart
  const cart = new ShoppingCart();
  window.cart = cart;

  // ============================================
  // 3. ADD TO CART BUTTONS
  // ============================================

  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
  addToCartButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productCard = this.closest('.product-card');
      const product = {
        id: productCard.dataset.productId,
        name: productCard.querySelector('.product-name').textContent,
        price: parseFloat(productCard.querySelector('.price-current').textContent),
        image: productCard.querySelector('.product-image img').src,
        quantity: 1
      };

      cart.addItem(product);
      
      // Visual feedback
      this.textContent = 'تمت الإضافة ✓';
      this.disabled = true;
      
      setTimeout(() => {
        this.textContent = 'أضف إلى السلة';
        this.disabled = false;
      }, 2000);
    });
  });

  // ============================================
  // 4. WISHLIST FUNCTIONALITY
  // ============================================

  class Wishlist {
    constructor() {
      this.items = this.loadWishlist();
    }

    loadWishlist() {
      const saved = localStorage.getItem('nashmi_wishlist');
      return saved ? JSON.parse(saved) : [];
    }

    saveWishlist() {
      localStorage.setItem('nashmi_wishlist', JSON.stringify(this.items));
    }

    toggleItem(productId) {
      const index = this.items.indexOf(productId);
      if (index > -1) {
        this.items.splice(index, 1);
      } else {
        this.items.push(productId);
      }
      this.saveWishlist();
      return index === -1; // Returns true if item was added
    }

    isInWishlist(productId) {
      return this.items.includes(productId);
    }
  }

  const wishlist = new Wishlist();
  window.wishlist = wishlist;

  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  wishlistButtons.forEach(btn => {
    const productId = btn.closest('.product-card').dataset.productId;
    
    // Set initial state
    if (wishlist.isInWishlist(productId)) {
      btn.classList.add('active');
    }

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const isAdded = wishlist.toggleItem(productId);
      this.classList.toggle('active', isAdded);
    });
  });

  // ============================================
  // 5. PRODUCT FILTERING & SORTING
  // ============================================

  const filterButtons = document.querySelectorAll('.filter-btn');
  const sortSelect = document.querySelector('.sort-select');
  const productCards = document.querySelectorAll('.product-card');

  filterButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      filterButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      
      const category = this.dataset.category;
      filterProducts(category);
    });
  });

  function filterProducts(category) {
    productCards.forEach(card => {
      if (category === 'all' || card.dataset.category === category) {
        card.style.display = 'block';
        setTimeout(() => card.classList.add('fade-in'), 10);
      } else {
        card.style.display = 'none';
      }
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      sortProducts(this.value);
    });
  }

  function sortProducts(sortBy) {
    const container = document.querySelector('.products-grid');
    const cards = Array.from(productCards);

    cards.sort((a, b) => {
      const priceA = parseFloat(a.querySelector('.price-current').textContent);
      const priceB = parseFloat(b.querySelector('.price-current').textContent);

      switch(sortBy) {
        case 'price-low':
          return priceA - priceB;
        case 'price-high':
          return priceB - priceA;
        case 'newest':
          return b.dataset.productId - a.dataset.productId;
        default:
          return 0;
      }
    });

    cards.forEach(card => container.appendChild(card));
  }

  // ============================================
  // 6. SEARCH FUNCTIONALITY
  // ============================================

  const searchInput = document.querySelector('.search-input');
  
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      const searchTerm = e.target.value.toLowerCase();
      
      productCards.forEach(card => {
        const productName = card.querySelector('.product-name').textContent.toLowerCase();
        
        if (productName.includes(searchTerm)) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }

  // ============================================
  // 7. QUANTITY SELECTOR
  // ============================================

  const quantityInputs = document.querySelectorAll('.quantity-input');
  
  quantityInputs.forEach(input => {
    const minusBtn = input.parentElement.querySelector('.qty-minus');
    const plusBtn = input.parentElement.querySelector('.qty-plus');

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        input.value = Math.max(1, parseInt(input.value) - 1);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        input.value = parseInt(input.value) + 1;
      });
    }
  });

  // ============================================
  // 8. FORM VALIDATION
  // ============================================

  const forms = document.querySelectorAll('form');
  
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      let isValid = true;
      const inputs = this.querySelectorAll('[required]');

      inputs.forEach(input => {
        if (!input.value.trim()) {
          isValid = false;
          input.classList.add('error');
        } else {
          input.classList.remove('error');
        }
      });

      if (!isValid) {
        e.preventDefault();
        showErrorMessage('يرجى ملء جميع الحقول المطلوبة');
      }
    });
  });

  function showErrorMessage(message) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'notification notification-error';
    errorDiv.textContent = message;
    document.body.appendChild(errorDiv);

    setTimeout(() => {
      errorDiv.classList.add('show');
    }, 10);

    setTimeout(() => {
      errorDiv.classList.remove('show');
      setTimeout(() => errorDiv.remove(), 300);
    }, 3000);
  }

  // ============================================
  // 9. SMOOTH SCROLLING
  // ============================================

  const smoothScrollLinks = document.querySelectorAll('a[href^="#"]');
  
  smoothScrollLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // ============================================
  // 10. LAZY LOADING IMAGES
  // ============================================

  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    });

    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // ============================================
  // 11. SCROLL TO TOP BUTTON
  // ============================================

  const scrollToTopBtn = document.querySelector('.scroll-to-top');
  
  if (scrollToTopBtn) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        scrollToTopBtn.classList.add('visible');
      } else {
        scrollToTopBtn.classList.remove('visible');
      }
    });

    scrollToTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  // ============================================
  // 12. ACCORDION (FAQ)
  // ============================================

  const accordionItems = document.querySelectorAll('.accordion-item');
  
  accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-header');
    
    if (header) {
      header.addEventListener('click', function() {
        const isActive = item.classList.contains('active');
        
        // Close all other items
        accordionItems.forEach(otherItem => {
          otherItem.classList.remove('active');
        });

        // Toggle current item
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });

  // ============================================
  // 13. NOTIFICATION STYLES
  // ============================================

  const style = document.createElement('style');
  style.textContent = `
    .notification {
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 16px 24px;
      border-radius: 8px;
      font-weight: 500;
      z-index: 1000;
      opacity: 0;
      transform: translateX(400px);
      transition: all 300ms ease-in-out;
    }

    .notification.show {
      opacity: 1;
      transform: translateX(0);
    }

    .notification-success {
      background-color: #28a745;
      color: white;
    }

    .notification-error {
      background-color: #dc3545;
      color: white;
    }

    .form-input.error,
    .form-textarea.error {
      border-color: #dc3545;
      background-color: rgba(220, 53, 69, 0.05);
    }

    .scroll-to-top {
      position: fixed;
      bottom: 20px;
      left: 20px;
      width: 50px;
      height: 50px;
      background-color: #0A1929;
      color: white;
      border: none;
      border-radius: 50%;
      cursor: pointer;
      opacity: 0;
      visibility: hidden;
      transition: all 300ms ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
    }

    .scroll-to-top.visible {
      opacity: 1;
      visibility: visible;
    }

    .scroll-to-top:hover {
      background-color: #D4AF37;
      color: #0A1929;
    }

    .accordion-item {
      border-bottom: 1px solid #E5E5E7;
    }

    .accordion-header {
      padding: 16px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 300ms ease-in-out;
    }

    .accordion-header:hover {
      background-color: #F5F5F7;
    }

    .accordion-item.active .accordion-header {
      color: #D4AF37;
    }

    .accordion-content {
      max-height: 0;
      overflow: hidden;
      transition: max-height 300ms ease-in-out;
    }

    .accordion-item.active .accordion-content {
      max-height: 500px;
      padding: 0 16px 16px;
    }
  `;
  document.head.appendChild(style);

  // ============================================
  // 14. INITIALIZATION
  // ============================================

  console.log('NASHMI Store - Custom Scripts Loaded Successfully');

})();
